import React, { useState, useEffect, useRef } from "react";

//component
import WmsButton from "../components/WmsButton/WmsButton.jsx";
import { StringWms } from "../../../assets/ts/StringWms";
import WmsInput from "../components/WmsInput/WmsInput.jsx";
import WmsDropdown from "../components/WmsDropdown/WmsDropdown.jsx";
import WmsCheckBox from "../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsCollapse from "../components/WmsCollapse/WmsCollapse.jsx";
import "./audit-inventory.scss";
import * as GlobalService from "../global_services.js";

import * as auditInventoryServices from "./audit-inventory.services";

interface Props {
    selector: string;
    windowId: string;
    userOptions: any;
    isSectionToggled: boolean;
    showSummary: boolean;
    onClickForFilterToggle: () => void;
    onApplyFilter: () => void;
    OnFacilitySelect: (facUri: any) => void;
}
const defaultFilterValue = {
    IndexOptionsJobName: 0,
    IndexOptionsStatus: -2,
    IndexOptionsUserName: -1,
    JobName: null,
    Status: "All",
    UserName: null,
    TrackBys: false,
};

declare var window: any;

const AuditInventorySearch: React.FC<Props> = (props: Props): any => {
    const CustomLabels = GlobalService.getCustomLabels();
    const optionContains = StringWms.convertSringToOption(window.translate("Options_SearchBy_StringOptions"));
    const [booleanOption, setBooleanOption] = useState([]);
    const [filter, setFilter] = useState(defaultFilterValue);
    const [userOption, setUserOption] = useState([]);
    const facilityOption = GlobalService.getFacilityList(false).sort((a, b) => a.name.localeCompare(b.name));
    const [selectedFacility, setSelectedFacilty] = useState(0);
    const facilityRef = useRef(false);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    useEffect(() => {
        initialsOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setUserOption(props.userOptions);
    }, [props.userOptions]);

    const initialsOptions = () => {
        let tmpBooleanOptions = StringWms.convertSringToOption(window.translate("Options_CycleCount_StatusOption"));
        tmpBooleanOptions.push({
            value: -1,
            description: "All",
        });
        tmpBooleanOptions.unshift({
            value: -2,
            description: "Not Closed",
        });
        setBooleanOption(tmpBooleanOptions);
        auditInventoryServices.auditSearchInfo(filter).then((response) => {});
    };
    const clearFilters = () => {
        let resetFilterObj = defaultFilterValue;
        setSelectedFacilty(null);
        props.OnFacilitySelect(null);
        setFilter(resetFilterObj);
    };
    const onFilterApply = (filter: any) => {
        if (!facilityRef.current) {
            return;
        }
        if (filter.IndexOptionsUserName === 0) {
            filter.UserName = null;
        } else if (filter.IndexOptionsUserName > 0) {
            // eslint-disable-next-line array-callback-return
            userOption.filter((item) => {
                if (item.Id === filter.IndexOptionsUserName) {
                    filter.UserName = item["Name"];
                }
            });
        } else {
            filter.IndexOptionsUserName = -1;
            filter.UserName = null;
        }
        auditInventoryServices
            .auditSearchInfo(filter)
            .then((response) => {
                props.onApplyFilter();
            })
            .finally(() => {});
    };

    const OnFacilityChange = (e) => {
        let facilityId = e.target.value;
        // eslint-disable-next-line eqeqeq
        var facObj = facilityOption.find((x) => x.id == facilityId);
        setSelectedFacilty(facilityId);
        props.OnFacilitySelect(facObj);
        if (facObj) {
            facilityRef.current = true;
            onFilterApply(filter);
        }
    };

    const debounceFilterApply = GlobalService.useFCDebounce(onFilterApply, 700);
    const onSearchFilterChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "IndexOptionsUserName") {
            value = parseInt(value);
        }
        if (name === "TrackBys") {
            value = e.target.checked;
        }
        setFilter((previousFilter) => {
            const tempFilter = {
                ...previousFilter,
                [name]: value,
            };
            debounceFilterApply(tempFilter);
            return tempFilter;
        });
    };

    return (
        <div className={`audit-inventory-search-holder ${props.isSectionToggled ? " sectionToggled " : ""}`}>
            {props.showSummary && showTooltip ? (
                <div className="wms-tooltip-content">{window.translate("Audit_Inventory_Filter_Section_Tooltip")}</div>
            ) : (
                ""
            )}
            <div
                className="filter"
                onClick={props.showSummary ? null : props.onClickForFilterToggle}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <i className="fa fa-caret-left" aria-hidden="true"></i>
                <span>search filters</span>
            </div>
            <div className="inventory-filter">
                <div className="filter-wrapper">
                    <div className="btn-section">
                        <WmsButton
                            label={window.translate("Label_Clear_Filters")}
                            buttonType="yellow"
                            wmsSelector={props.selector + "ClearSearchButton"}
                            onClickFunc={clearFilters}
                            icon="fa-minus"
                        />
                    </div>

                    <div className={"warehouse-form-boxes"}>
                        <div className="warehouse-are-content" id="inventory-filter-section-sortable">
                            <WmsCollapse
                                id={"inventory_search_collapse1"}
                                showDragIcon={true}
                                headerLabel={window.translate("Label_Filter_Options")}
                                showCollapseText={false}
                            >
                                <WmsDropdown
                                    id="indexOptionsWarehouse"
                                    name="indexOptionsWarehouse"
                                    label={CustomLabels.Label_Warehouse}
                                    wmsSelector={props.selector + "warehouseDropdown"}
                                    value={selectedFacility}
                                    onChangeFunc={OnFacilityChange}
                                    options={facilityOption}
                                    valueField="id"
                                    textField="name"
                                    parentClassName="form_group"
                                    required={true}
                                    blankFirstOption={true}
                                    blankFirstOptionText={""}
                                />
                                <div className="wms-input-group-wrapper">
                                    <WmsDropdown
                                        id="IndexOptionsJobName"
                                        name="IndexOptionsJobName"
                                        windowId={props.windowId}
                                        label={window.translate("Label_Cycle_count_Job_Name")}
                                        wmsSelector={props.selector + "IndexOptionsJobName"}
                                        value={filter.IndexOptionsJobName}
                                        onChangeFunc={onSearchFilterChange}
                                        options={optionContains}
                                        valueField="value"
                                        textField="description"
                                        parentClassName="select_box"
                                    />
                                    <WmsInput
                                        inputName="JobName"
                                        wmsSelector={props.selector + "SearchJobName"}
                                        value={filter.JobName}
                                        onChangeFunc={onSearchFilterChange}
                                        label={window.translate("Label_Cycle_count_Job_Name")}
                                        parentClassName="input_box"
                                    />
                                </div>
                                <WmsDropdown
                                    id="IndexOptionsStatus"
                                    name="IndexOptionsStatus"
                                    label={"Job Status"}
                                    wmsSelector={props.selector + "IndexOptionsStatus"}
                                    value={filter.IndexOptionsStatus}
                                    onChangeFunc={onSearchFilterChange}
                                    options={booleanOption}
                                    valueField="value"
                                    textField="description"
                                />
                                <WmsDropdown
                                    id="IndexOptionsUserName"
                                    name="IndexOptionsUserName"
                                    label={"Assigned To"}
                                    wmsSelector={props.selector + "SearchUserName"}
                                    value={filter.IndexOptionsUserName}
                                    onChangeFunc={onSearchFilterChange}
                                    options={userOption}
                                    valueField="Id"
                                    textField="Name"
                                    blankFirstOption={true}
                                    blankFirstOptionText={window.translate("Label_All")}
                                />
                                <WmsCheckBox
                                    id={"TrackBys"}
                                    name={"TrackBys"}
                                    wmsSelector={props.selector + "SearchTrackBys"}
                                    onChangeFunc={onSearchFilterChange}
                                    label={window.translate("Label_Cycle_count_Job_includes")}
                                    checked={filter.TrackBys}
                                />
                            </WmsCollapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
AuditInventorySearch.propTypes = {};

export default React.memo(AuditInventorySearch);
